export default __webpack_public_path__ + "static/media/calender.a8726a75.svg";